exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.attachment-picker-container[data-v-54292c37] {\n  padding: 16px;\n}\n.drag-drop-zone[data-v-54292c37] {\n  background-color: #f7fafc;\n  text-align: center;\n  padding: 4rem;\n}\n.hidden-file-input[data-v-54292c37] {\n  display: none;\n}\n.file-input-trigger[data-v-54292c37] {\n  cursor: pointer;\n  color: #2a9811;\n  /* Style as needed */\n}\n.file-item[data-v-54292c37] {\n  margin-bottom: 10px;\n}\n.hidden-file-input[data-v-54292c37] {\n  display: none;\n}\n", ""]);

// exports
